import { Card, Table } from 'antd';
import styled from 'styled-components';

export const ActionContainer = styled('div')`
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: center;
  gap: 8px;
`;

export const ContainerTable = styled.div`
  box-shadow: 0 4px 6px -1px rgb(113 126 195 / 10%), 0 2px 4px -2px rgb(113 126 195 / 10%);
`;

export const TableTitleButtonContainer = styled('div')`
  display: flex;
  align-items: center;
  gap: 8px;
  flex-flow: row wrap;
  overflow: visible;
  max-width: 100%;
`;

export const TitleContainer = styled('div')`
  display: flex;
  flex-flow: row wrap;
  justify-content: space-between;
  align-items: center;
  gap: 1rem;

  width: 100%;
  padding: 10px 0;
`;
export const StyledTable = styled(Table)`
  .ant-table-container {
    border: none !important;
    border-radius: 0 !important;

    table > thead > tr .ant-table-cell {
      font-weight: 600;
      &:nth-child(1) {
        background: #fcf3cf;
      }
      &:nth-child(2) {
        background: #91d5ff;
      }
      &:nth-child(3) {
        background: #adc6ff;
      }
      &:nth-child(4) {
        background: #b7eb8f;
      }
      &:nth-child(5) {
        background: #fcf3cf;
      }
      &:nth-child(6) {
        background: #91d5ff;
      }
      &:nth-child(7) {
        background: #adc6ff;
      }
      &:nth-child(8) {
        background: #b7eb8f;
      }
    }

    > * {
      border-radius: 0 !important;
    }

    table > thead > tr:first-child th:first-child,
    th.ant-table-cell {
      // background: rgb(145, 213, 255);
      color: rgba(0, 0, 0, 0.85);
    }

    .ant-table-cell {
      padding: 6px 10px !important;
    }
  }

  tbody > tr > td {
    font-size: 14px;
    font-weight: 500;
    color: #183459;
  }

  tbody tr:last-child > td {
    border-bottom: none !important;
  }
`;

export const ScrollContainer = styled('div')`
  overflow-x: auto;
  width: 100%;
  padding: 1px 0;
  outline: 0.5px solid #f0f0f0;
`;

export const TableContainer = styled(Card)`
  width: 100%;
  border-radius: 4px;
  border: 1px solid #f0f0f0;
  box-shadow: 0 4px 6px -1px rgb(113 126 195 / 10%), 0 2px 4px -2px rgb(113 126 195 / 10%);
  overflow: hidden;

  .ant-card-head {
    color: #183459;
    padding: 0 16px;
    font-size: 14px;
    font-weight: 600;
  }

  .ant-card-head-title {
    overflow: visible;
  }

  .ant-card-body {
    padding: 0 !important;
  }
`;

export const TableContentContainer = styled('div')`
  width: 100%;
`;

export const PaginationContainer = styled('div')`
  display: flex;
  align-items: center;
  justify-content: center;

  width: 100%;
  height: 64px;
  padding: 16px;

  position: relative;
`;
